import { useTranslation } from "react-i18next";

type SmoobuApiSecretFieldProps = {
    value: string;
    onChange: (value: string) => void;
    // A secret is stored and still applies to the apikey in the form.
    secretKept: boolean;
    readOnly: boolean;
    hasError: boolean;
};

// Smoobu stops accepting bare API keys on 31-oct-2026: requests must be signed
// with the account's API secret. The secret is write-only, so an empty field
// keeps the stored one and the placeholder says whether there is one.
export function SmoobuApiSecretField({ value, onChange, secretKept, readOnly, hasError }: SmoobuApiSecretFieldProps) {
    const { t } = useTranslation();

    return (
        <div className="col-span-full">
            <label className="font-weight-bold mb-1 d-block">API Secret</label>
            <input
                className={`${hasError ? 'input-error' : ''} ${readOnly ? 'cna' : ''} w-100 p-2 c-h-min c-input-bordered`}
                type="password"
                autoComplete="new-password"
                readOnly={readOnly}
                value={value}
                placeholder={secretKept ? t("mod_integrations_smoobu_api_secret_saved") : "API Secret"}
                onChange={(e) => onChange(e.target.value?.trim())}
            />
            <span className="small text-muted d-block mt-1">{t("mod_integrations_smoobu_api_secret_help")}</span>
            {!secretKept && !value && (
                <div className="alert alert-warning small mt-2 mb-0">
                    {t("mod_integrations_smoobu_api_secret_missing")}
                </div>
            )}
        </div>
    );
}
